module.exports = [ 'the', 'a', 'an', 'some' ]
